const newProjectData = {
  title: 'Create New Project',
  description:
    'Looks like there is nothing yet, please create a new ELA project to start running analysis',
};

export default newProjectData;
